
import {NullUUID} from "./DBUtils";

class ResourceId {
    static get NoResource() {
        return new ResourceId("--No Resource--", NullUUID)
    }
    constructor(type, id) {
        this.type = type;
        this.id = id;
    }
}

export default ResourceId;


// WEBPACK FOOTER //
// ./public/utils/ResourceId.js